module.exports = __webpack_public_path__ + "img/DAY1-3.8a28dbd6.jpg";